<template>
<div class="ActivityTempGoodsList">
    <activityGoodsList></activityGoodsList>
</div>
</template>

<script>
import ActivityGoodsList from 'views/brandBusiness/activityMgt/activity/ActivityGoodsList.vue'
export default {
    name: 'ActivityTempGoodsList',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {
        ActivityGoodsList
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ActivityTempGoodsList {
}
</style>
